import React, { useState } from "react";
import { useParams } from "react-router-dom";

// import JS files
import Header from "../shares/others/Header";
import MuiTextField from "../shares/mui/MuiTextField";
import MuiTextArea from "../shares/mui/MuiTextArea";
import MuiButton from "../shares/mui/MuiButton";
import useFetch from "../../context/useFetch";

// import others files

const CommentForm = (props) => {
  const {id} = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [description, setDescription] = useState("");
  const [postData, setPostData] = useState();

  const createCommentApi = useFetch({
    method: "post",
    url: `NewsComment_Service`,
    data: postData,
    noHeader: true,
    argFunc: (res) => {
      setName("");
      setDescription("");
      setEmail("");
    },
  });

  const on_submit = () => {
    setPostData({ name, email, comment: description , news:id });
    createCommentApi.reFetch();
  };
  return (
    <>
      <div className=" mt-12">
        <Header header="نظر شما" noAllItems />
        <div className="mt-8 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <div className="">
              <MuiTextField
                id="name"
                label="نام"
                variant="outlined"
                size="small"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
            </div>
            <div className="mt-8">
              <MuiTextField
                id="name"
                label="پست الکترونیک"
                variant="outlined"
                size="small"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                isLTR
              />
            </div>
          </div>
          <div className=" md:col-span-7">
            <div className="">
              <MuiTextArea
                id="name"
                label="توضیحات ..."
                variant="outlined"
                size="small"
                onChange={(e) => setDescription(e.target.value)}
                value={description}
              />
            </div>
          </div>
        </div>
        <div className="mt-4 md:mt-8 flex justify-end">
          <MuiButton
            disabled={name == "" || email == "" || description == ""}
            variant="contained"
            color="primary"
            text="ارسال نظر"
            type="submit"
            // withoutOnClick
            onClick={on_submit}
          />
        </div>
      </div>
    </>
  );
};

export default CommentForm;
